import React from 'react';
import { Textarea, TextareaProps, ReadOnlyField } from '@indigo-ag/component-module';

import { utils } from 'shared';

interface EditableTextFieldProps {
  label: string;
  value: string;
  readonly?: boolean;
}

export const EditableTextArea: React.FunctionComponent<EditableTextFieldProps & TextareaProps> = ({
  label,
  value,
  readonly = false,
  ...textAreaProps
}) => {
  const labelTitle = utils.text.toTitleCase(label);

  return readonly ? (
    <ReadOnlyField label={labelTitle} value={value || '-'} />
  ) : (
    <Textarea label={labelTitle} rows={4} value={value} {...textAreaProps} />
  );
};
